const URL = 'https://lang.api.news.bitcoin.com/wp-json/bcn/v1/log';

export const remoteLog = async message => {
  if (!message) return;

  try {
    await fetch(URL, {
      method: 'POST',
      body: JSON.stringify({ error: message }),
    });
  } catch (e) {
    console.error(e);
  }
};
